import * as mutationTypes from 'store/mutationTypes'

/**
 * @return {Promise}
 */
export const showChatApp = function ({ commit }) {
  return commit(mutationTypes.SHOW_CHAT_APP)
}

/**
 * @return {Promise}
 */
export const hideChatApp = function ({ commit }) {
  return commit(mutationTypes.HIDE_CHAT_APP)
}

/**
 * @return {Promise}
 */
export const toggleChatApp = function ({ commit }) {
  return commit(mutationTypes.TOGGLE_CHAT_APP)
}



// WEBPACK FOOTER //
// ./src/store/modules/chatApp/actions.js